const SubmitButton = ({ value }) => {
    return (
        <div className="mb__form-submit">
            <button>{value}</button>
        </div>
    );
};

export default SubmitButton;